import type { FC, ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { CircularLoader } from "app/components/React/CircularLoader/CircularLoader";

import { StyledLoadingToast, StyledToastContent } from "./styles";

type LoadingToastProps = { content: ReactNode; hideCloseIcon?: boolean };

const LoadingToast: FC<LoadingToastProps> = ({ content, hideCloseIcon = false }) => {
    return (
        <StyledLoadingToast hideCloseIcon={hideCloseIcon}>
            <StyledToastContent withContentPadding={!hideCloseIcon}>{content}</StyledToastContent>
            <CircularLoader options={{ svg: { stroke: colorsPalettes.midnight["50"] } }} />
        </StyledLoadingToast>
    );
};

export const renderLoadingToast = (props: LoadingToastProps) => <LoadingToast {...props} />;
